import { render, staticRenderFns } from "./cms.vue?vue&type=template&id=1c0f8116&scoped=true"
import script from "./cms.vue?vue&type=script&lang=js"
export * from "./cms.vue?vue&type=script&lang=js"
import style0 from "./cms.vue?vue&type=style&index=0&id=1c0f8116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f8116",
  null
  
)

export default component.exports